const prefix = '/funds';

export const ApiFundsUrls = {
  fundFromOrigin: `${prefix}/fund-from-origin`,
};
